import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import GearIcon from "./icons/GearIcon";
const FunctionalButton = (props) => {
    let [over, setOver] = useState(false);
    let textColor = 'pink';
    let backgroundColor = 'red';
    let borderColor = 'blue';
    let borderThickness = '1px';
    let textDecoration = 'none';
    const text = props.isRound ? props.text : props.text.toUpperCase();
    const paddingButton = props.isRound ? '5px 16px' : '10px 16px';
    const borderRadius = props.isRound ? '16px' : '0px';
    const height = props.isRound ? '30px' : '50px';
    if (props.colorMode === 0) {
        textColor = 'white';
        borderColor = 'transparent';
        borderThickness = '0px';
        if (props.enabled) {
            backgroundColor = '#54659F';
            if (over) {
                backgroundColor = '#38487E';
            }
        }
        else {
            backgroundColor = '#A1AABC';
        }
    }
    if (props.colorMode === 1) {
        backgroundColor = 'white';
        borderColor = '#54659F';
        borderThickness = props.isRound ? '1px' : '2px';
        textColor = '#333333';
        if (props.enabled) {
            if (over) {
                backgroundColor = '#F3F6FF';
            }
        }
        else {
            textColor = '#A1AABC';
            borderColor = '#A1AABC';
        }
    }
    if (props.colorMode === 2) {
        textDecoration = 'underline';
        backgroundColor = 'white';
        borderColor = 'black';
        borderThickness = '0px';
        textColor = 'black';
        if (props.enabled) {
            if (over) {
                textColor = '#767676';
            }
        }
        else {
            textColor = '#A1AABC';
        }
    }
    function handleClick() {
        if (props.onClick) {
            props.onClick();
        }
    }
    const IconNode = props.icon;
    return (_jsxs("button", Object.assign({ disabled: !props.enabled, className: "flex items-center flex-row font-roboto h-full", style: {
            backgroundColor: backgroundColor,
            borderColor: borderColor, borderStyle: 'solid', borderWidth: borderThickness, borderRadius: borderRadius,
            fontWeight: '700', fontSize: props.fontSize,
            color: textColor,
            gap: '4px', height: height, padding: paddingButton,
        }, onMouseOver: () => setOver(true), onMouseOut: () => setOver(false), onClick: handleClick }, { children: [props.showLeftIcon ? _jsx(IconNode, { color: textColor }) : _jsx(_Fragment, {}), _jsx("div", Object.assign({ className: "flex", style: {
                    textDecoration: textDecoration,
                    whiteSpace: 'nowrap',
                } }, { children: text })), props.showRightIcon ? _jsx(IconNode, { color: textColor }) : _jsx(_Fragment, {})] })));
};
FunctionalButton.defaultProps = {
    onClick: undefined,
    enabled: true,
    showLeftIcon: false,
    showRightIcon: false,
    colorMode: 0,
    icon: GearIcon,
    fontSize: '14px',
    isRound: true,
};
export default FunctionalButton;
